import { render, staticRenderFns } from "./ConfigItem.vue?vue&type=template&id=cdffe532&scoped=true&"
import script from "./ConfigItem.vue?vue&type=script&lang=js&"
export * from "./ConfigItem.vue?vue&type=script&lang=js&"
import style0 from "./ConfigItem.vue?vue&type=style&index=0&id=cdffe532&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdffe532",
  null
  
)

export default component.exports